// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Sheet from "../../primitives/Sheet.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Accounting from "@wino/accounting/src/Accounting.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as CartProduct from "../Cart/CartProduct.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as OrderCsvImporting__Config from "./OrderCsvImporting__Config.res.js";
import * as OrderCsvImporting__Queries from "./OrderCsvImporting__Queries.res.js";

let OrderCsvParserAndDecoder = Sheet.CsvParserAndDecoder(OrderCsvImporting__Config.ParserConfig);

let OrderCsvImporting_TaxValueNotFound = /* @__PURE__ */Primitive_exceptions.create("OrderCsvImporting.OrderCsvImporting_TaxValueNotFound");

function make(file, client, notifier, hasCavavinPermission, cartProducts, cartDispatch, onRequestCartLoading) {
  Future.get(Future.mapOk(OrderCsvParserAndDecoder.make(file.src), undefined, value => {
    let data = value[0];
    let fetchingVariants = {
      contents: []
    };
    let fetchedValidCount = {
      contents: 0
    };
    let fetchedInvalidCount = {
      contents: 0
    };
    let updatedValidCount = {
      contents: 0
    };
    notifier.clear();
    onRequestCartLoading({
      message: undefined
    });
    cartProducts.forEach(product => {
      let match;
      if (product.TAG === "Unit") {
        let match$1 = product._0;
        match = [
          match$1.id,
          match$1.stockKeepingUnit
        ];
      } else {
        let match$2 = product._0;
        match = [
          match$2.id,
          match$2.stockKeepingUnit
        ];
      }
      let sku = match[1];
      let match$3 = data.some(current => Primitive_object.equal(current.sku, sku));
      if (match$3) {
        return;
      } else {
        return cartDispatch({
          TAG: "ProductRemoved",
          _0: match[0]
        });
      }
    });
    data.forEach(param => {
      let unitPrice = param.unitPrice;
      let quantity = param.quantity;
      let sku = param.sku;
      let match = Stdlib_Array.filterMap(cartProducts, product => {
        let match;
        if (product.TAG === "Unit") {
          let match$1 = product._0;
          match = [
            match$1.id,
            match$1.stockKeepingUnit
          ];
        } else {
          let match$2 = product._0;
          match = [
            match$2.id,
            match$2.stockKeepingUnit
          ];
        }
        let currentSku = match[1];
        if (currentSku !== undefined && currentSku === sku) {
          return [
            match[0],
            Accounting.isBulk(product)
          ];
        }
      });
      if (match.length !== 1) {
        fetchingVariants.contents = Belt_Array.concatMany([
          fetchingVariants.contents,
          [Future.mapOk(OrderCsvImporting__Queries.Fetch.fetchVariantFromSKU(client, file.shopId, sku), undefined, response => {
              if (response !== undefined) {
                fetchedValidCount.contents = fetchedValidCount.contents + 1 | 0;
                onRequestCartLoading({
                  message: I18n.template(I18n.t("{{count}} products loaded out of {{total}}"), {
                    count: fetchedValidCount.contents.toString(),
                    total: fetchingVariants.contents.length.toString()
                  }, undefined)
                });
                return {
                  data: response,
                  file: {
                    TAG: "Ok",
                    _0: {
                      sku: sku,
                      quantity: quantity,
                      unitPrice: unitPrice
                    }
                  }
                };
              } else {
                fetchedInvalidCount.contents = fetchedInvalidCount.contents + 1 | 0;
                return {
                  data: undefined,
                  file: {
                    TAG: "Error",
                    _0: sku
                  }
                };
              }
            })]
        ]);
        return;
      }
      let match$1 = match[0];
      let cartProductId = match$1[0];
      updatedValidCount.contents = updatedValidCount.contents + 1 | 0;
      cartDispatch({
        TAG: "ProductExpectedQuantityUpdated",
        _0: cartProductId,
        _1: match$1[1] ? ({
            TAG: "BulkQuantity",
            _0: quantity
          }) : ({
            TAG: "UnitQuantity",
            _0: quantity | 0
          })
      });
      if (unitPrice !== undefined) {
        return cartDispatch({
          TAG: "ProductUnitPriceUpdated",
          _0: cartProductId,
          _1: unitPrice
        });
      }
    });
    let parsingErrors = value[1].map(error => I18n.template(I18n.t("{{msg}} at column {{col}} row {{row}}"), {
      row: error.rowIndex,
      col: error.entryIndex,
      msg: I18n.t(error.message)
    }, undefined));
    Future.get(Future.all(fetchingVariants.contents), results => {
      let productInputs = Stdlib_Array.filterMap(results, x => {
        if (x.TAG !== "Ok") {
          return;
        }
        let match = x._0;
        let variantData = match.data;
        if (variantData === undefined) {
          return;
        }
        let fileData = match.file;
        if (fileData.TAG !== "Ok") {
          return;
        }
        let fileData$1 = fileData._0;
        let match$1 = variantData.bulk;
        let tmp;
        if (match$1 !== undefined && match$1) {
          let precision = variantData.capacityPrecision;
          tmp = precision !== undefined ? precision : undefined;
        } else {
          tmp = undefined;
        }
        let productInput = CartProduct.makeProductInput(variantData.id, variantData.formattedName, variantData.formattedDescription, variantData.stockKeepingUnit, variantData.stock.rawQuantity, variantData.packaging, variantData.product.tax.value, variantData.purchasedPrice, undefined, tmp, variantData.capacityUnit, undefined);
        let updatedUnitPrice;
        let exit = 0;
        let unitPrice;
        if (productInput.TAG === "Unit") {
          unitPrice = productInput.product.unitPrice;
          exit = 1;
        } else {
          unitPrice = productInput.product.unitPrice;
          exit = 1;
        }
        if (exit === 1) {
          let unitPrice$1 = fileData$1.unitPrice;
          updatedUnitPrice = unitPrice$1 !== undefined ? unitPrice$1 : unitPrice;
        }
        let tmp$1;
        if (productInput.TAG === "Unit") {
          let product = productInput.product;
          tmp$1 = {
            TAG: "Unit",
            product: {
              id: product.id,
              identifier: product.identifier,
              stockKeepingUnit: product.stockKeepingUnit,
              name: product.name,
              description: product.description,
              capacityUnit: product.capacityUnit,
              stock: product.stock,
              packaging: product.packaging,
              quantity: fileData$1.quantity | 0,
              expectedQuantity: product.expectedQuantity,
              unitPrice: updatedUnitPrice,
              fees: product.fees,
              discounts: product.discounts,
              tax: product.tax
            }
          };
        } else {
          let product$1 = productInput.product;
          tmp$1 = {
            TAG: "Bulk",
            product: {
              id: product$1.id,
              identifier: product$1.identifier,
              stockKeepingUnit: product$1.stockKeepingUnit,
              name: product$1.name,
              description: product$1.description,
              capacityUnit: product$1.capacityUnit,
              stock: product$1.stock,
              packaging: product$1.packaging,
              quantity: fileData$1.quantity,
              expectedQuantity: product$1.expectedQuantity,
              unitPrice: updatedUnitPrice,
              fees: product$1.fees,
              discounts: product$1.discounts,
              tax: product$1.tax
            },
            precision: productInput.precision
          };
        }
        return tmp$1;
      });
      let errorsMessages = Stdlib_Array.filterMap(results, result => {
        if (result.TAG !== "Ok") {
          return;
        }
        let match = result._0;
        if (match.data !== undefined) {
          return;
        }
        let sku = match.file;
        if (sku.TAG === "Ok") {
          return;
        } else {
          return I18n.template(I18n.t("{{sku}} could not be found in the current catalog (SKU)"), {
            sku: sku._0
          }, undefined);
        }
      });
      cartDispatch({
        TAG: "BatchProductAdded",
        _0: productInputs
      });
      onRequestCartLoading(undefined);
      if ((parsingErrors.length + fetchedInvalidCount.contents | 0) > 0) {
        let count = parsingErrors.length + fetchedInvalidCount.contents | 0;
        let notFoundSkuErrorCount = errorsMessages.length;
        let message = hasCavavinPermission && notFoundSkuErrorCount > 0 ? I18n.template(I18n.t(count > 1 ? "{{count}} products from the imported CSV have not been added to the order, ℹ️ please contact « t.pradelle@cavavin.eu » to activate them." : "{{count}} product from the imported CSV has not been added to the order, ℹ️ please contact « t.pradelle@cavavin.eu » to activate it."), {
            count: count
          }, undefined) : I18n.template(I18n.t(count > 1 ? "{{count}} products from the imported CSV have not been added to the order" : "{{count}} product from the imported CSV have not been added to the order") + ".", {
            count: count
          }, undefined);
        notifier.add({
          TAG: "Error",
          _0: message
        }, Belt_Array.concatMany([
          parsingErrors,
          errorsMessages
        ]), undefined);
      }
      if (fetchedValidCount.contents > 0 || updatedValidCount.contents > 0) {
        return notifier.add({
          TAG: "Success",
          _0: I18n.template(I18n.t((parsingErrors.length + fetchedInvalidCount.contents | 0) > 0 ? "{{count}} products from the imported CSV have been successfully added to the cart!" : "All products from the imported CSV have been successfully added to the cart!"), {
            count: fetchedValidCount.contents + updatedValidCount.contents | 0
          }, undefined)
        }, undefined, undefined);
      }
    });
  }), result => {
    if (result.TAG === "Ok") {
      return;
    } else {
      return notifier.reset({
        TAG: "Error",
        _0: I18n.t("Something wrong happened when importing file, please try again.")
      }, undefined, undefined);
    }
  });
}

let CartConfig;

let Config;

let Fetch;

export {
  CartConfig,
  Config,
  Fetch,
  OrderCsvParserAndDecoder,
  OrderCsvImporting_TaxValueNotFound,
  make,
}
/* OrderCsvParserAndDecoder Not a pure module */
